module.exports = __webpack_public_path__ + "static/media/docker-ico-white.91852160.svg";